/* eslint-disable no-underscore-dangle */
import { Icon } from 'assets/index'
import { Loading } from 'components/index'
import { useState } from 'react'
import { useFetch } from 'hooks'
import { Container, CardExtract } from './style'

interface IExtractProps {
  data: any
}

function base64ToString(base64: string): string {
  // Decodifica o Base64 para um array de bytes
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
  // Converte o array de bytes em uma string UTF-8
  const decodedString = new TextDecoder('utf-8').decode(bytes)
  return decodedString
}

export default function Extract(props: IExtractProps) {
  const { data } = props
  const [details, setDetails] = useState<any>(null)
  const api = useFetch()

  const formatDate = (date: any) => {
    const day = new Date(`${date}T00:00:00`)
    // console.log(day)
    const dayOfWeek = day.getDay()

    let newDate = ''

    if (dayOfWeek === 1) newDate += 'Segunda, '
    else if (dayOfWeek === 2) newDate += 'Terça, '
    else if (dayOfWeek === 3) newDate += 'Quarta, '
    else if (dayOfWeek === 4) newDate += 'Quinta, '
    else if (dayOfWeek === 5) newDate += 'Sexta, '
    else if (dayOfWeek === 6) newDate += 'Sábado, '
    else newDate += 'Domingo, '

    newDate += `${day.getDate() < 10 ? `0${day.getDate()}` : day.getDate()}`

    const month = day.getMonth()

    if (month === 0) newDate += ' Jan'
    else if (month === 1) newDate += ' Fev'
    else if (month === 2) newDate += ' Mar'
    else if (month === 3) newDate += ' Abr'
    else if (month === 4) newDate += ' Mai'
    else if (month === 5) newDate += ' Jun'
    else if (month === 6) newDate += ' Jul'
    else if (month === 7) newDate += ' Ago'
    else if (month === 8) newDate += ' Set'
    else if (month === 9) newDate += ' Out'
    else if (month === 10) newDate += ' Nov'
    else newDate += ' Dez'

    return newDate
  }

  const showDetails = (transaction: any) => {
    api
      .fetch('get', null, `/gestor/statement?id=${transaction.id}`)
      .then((response) => {
        if (!response.data) return
        // const html = atob(response.data.data)
        const html = base64ToString(response.data.data)
        setDetails(html)
      })
  }

  if (!data) return <Loading modal />
  return (
    <Container>
      <div className="extrato-container">
        <div className="extrato-left">
          <div className="extract-title">
            <img
              className="extract-title-img"
              src={Icon('invest.svg')}
              alt="extract icon"
            />
            <span className="extract-title-span">Extrato</span>
          </div>
          {/* {console.log(data)} */}
          {Object.keys(data).map((date: any) => {
            return (
              <div className="extract-date-container">
                <span className="extract-date-title">{formatDate(date)}</span>
                {data[date].map((transaction: any) => {
                  return (
                    <CardExtract
                      selected={details?._id === transaction?._id}
                      onClick={() => showDetails(transaction)}
                    >
                      <img
                        className="extract-card-img"
                        src={Icon('money.svg')}
                        alt="extract icon"
                      />
                      <div className="extract-date-info-container">
                        <span className="extract-date-info-title">
                          {transaction.label}
                        </span>
                        <span
                          className={
                            transaction.value.includes('+')
                              ? 'extract-date-info-positive-value'
                              : 'extract-date-info-negative-value'
                          }
                        >
                          {transaction.value}
                        </span>
                        <span className="extract-date-info-origin">
                          {transaction.target}
                        </span>
                      </div>
                      <span className="extract-date-clock">
                        {`${
                          transaction.createdAt.split('T')[1].split(':')[0]
                        }:${transaction.createdAt.split('T')[1].split(':')[1]}`}
                      </span>
                    </CardExtract>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div className="extrato-right">
          <div dangerouslySetInnerHTML={{ __html: details }} />
        </div>
      </div>
    </Container>
  )
}
